module.exports = __webpack_public_path__ + "static/img/bubbles2.30136c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bubbles2.png
// module id = 6/d7
// module chunks = 1